interface EnvironmentConfig {
  IAM_API_BASE_URL: string;
  B2C_CLIENT_ID: string;
  B2C_AUTHORITY: string;
  B2C_PASSWORD_RESET_AUTHORITY: string;
  B2C_MFA_MANAGEMENT_AUTHORITY: string;
  B2C_KNOWN_AUTHORITY: string;
  B2C_SCOPE: string;
  PIRAL_FEED_URL: string;
  DEBUG_PILET: string;
  USERFLOW_TOKEN: string;
  APPLICATION_INSIGHTS_CONNECTIONSTRING: string;
  MINIMUM_LOGLEVEL: number;
  DATADOG_APPLICATION_ID: string;
  DATADOG_CLIENT_TOKEN: string;
  DATADOG_SERVICE: string;
  DATADOG_ENV: string;
}

function validateEnvVar<T>(key: keyof EnvironmentConfig): T {
  let value: T;
  let emptyIsValid = false;
  switch (key) {
    case 'IAM_API_BASE_URL':
      value = process.env.REACT_APP_IAM_API_BASE_URL as T;
      break;
    case 'B2C_CLIENT_ID':
      value = process.env.REACT_APP_B2C_CLIENT_ID as T;
      break;
    case 'B2C_AUTHORITY':
      value = process.env.REACT_APP_B2C_AUTHORITY as T;
      break;
    case 'B2C_PASSWORD_RESET_AUTHORITY':
      value = process.env.REACT_APP_B2C_PASSWORD_RESET_AUTHORITY as T;
      break;
    case 'B2C_MFA_MANAGEMENT_AUTHORITY':
      value = process.env.REACT_APP_B2C_MFA_MANAGEMENT_AUTHORITY as T;
      break;
    case 'B2C_KNOWN_AUTHORITY':
      value = process.env.REACT_APP_B2C_KNOWN_AUTHORITY as T;
      break;
    case 'B2C_SCOPE':
      value = process.env.REACT_APP_B2C_SCOPE as T;
      break;
    case 'PIRAL_FEED_URL':
      value = process.env.REACT_APP_PIRAL_FEED_URL as T;
      break;
    case 'DEBUG_PILET':
      value = process.env.REACT_APP_DEBUG_PILET as T;
      break;
    case 'USERFLOW_TOKEN':
      value = process.env.REACT_APP_USERFLOW_TOKEN as T;
      emptyIsValid = true;
      break;
    case 'APPLICATION_INSIGHTS_CONNECTIONSTRING':
      value = process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTIONSTRING as T;
      break;
    case 'MINIMUM_LOGLEVEL':
      const minimumLogLevel = localStorage.getItem('minimumLogLevel');
      if (minimumLogLevel && Number.isInteger(Number(minimumLogLevel))) {
        value = Number(localStorage.getItem('minimumLogLevel')) as T;
      } else {
        value = Number(process.env.REACT_APP_MINIMUM_LOGLEVEL) as T;
      }
      break;
    case 'DATADOG_APPLICATION_ID':
      value = process.env.REACT_APP_DATADOG_APPLICATION_ID as T;
      break;
    case 'DATADOG_CLIENT_TOKEN':
      value = process.env.REACT_APP_DATADOG_CLIENT_TOKEN as T;
      break;
    case 'DATADOG_SERVICE':
      value = process.env.REACT_APP_DATADOG_SERVICE as T;
      break;
    case 'DATADOG_ENV':
      value = process.env.REACT_APP_DATADOG_ENV as T;
      break;
  }
  if (!value && !emptyIsValid) {
    throw new Error(`Environment variable REACT_APP_${key} is not set`);
  }
  return value;
}

export const env: EnvironmentConfig = {
  IAM_API_BASE_URL: validateEnvVar<string>('IAM_API_BASE_URL'),
  B2C_CLIENT_ID: validateEnvVar<string>('B2C_CLIENT_ID'),
  B2C_AUTHORITY: validateEnvVar<string>('B2C_AUTHORITY'),
  B2C_PASSWORD_RESET_AUTHORITY: validateEnvVar<string>(
    'B2C_PASSWORD_RESET_AUTHORITY'
  ),
  B2C_MFA_MANAGEMENT_AUTHORITY: validateEnvVar<string>(
    'B2C_MFA_MANAGEMENT_AUTHORITY'
  ),
  B2C_KNOWN_AUTHORITY: validateEnvVar<string>('B2C_KNOWN_AUTHORITY'),
  B2C_SCOPE: validateEnvVar<string>('B2C_SCOPE'),
  PIRAL_FEED_URL: validateEnvVar<string>('PIRAL_FEED_URL'),
  DEBUG_PILET: validateEnvVar<string>('DEBUG_PILET'),
  USERFLOW_TOKEN: validateEnvVar<string>('USERFLOW_TOKEN'),
  APPLICATION_INSIGHTS_CONNECTIONSTRING: validateEnvVar<string>(
    'APPLICATION_INSIGHTS_CONNECTIONSTRING'
  ),
  MINIMUM_LOGLEVEL: validateEnvVar<number>('MINIMUM_LOGLEVEL'),
  DATADOG_APPLICATION_ID: validateEnvVar<string>('DATADOG_APPLICATION_ID'),
  DATADOG_CLIENT_TOKEN: validateEnvVar<string>('DATADOG_CLIENT_TOKEN'),
  DATADOG_SERVICE: validateEnvVar<string>('DATADOG_SERVICE'),
  DATADOG_ENV: validateEnvVar<string>('DATADOG_ENV'),
};
